import React from 'react';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';

const TimeoutError = ({ timeout, handleAuthData }) => {
  return (
    <div className="row">
      <div className="col-md-6 col-lg-6 col-sm-6">
        <CustomInputWithIcon icon="number">
          <input
            type="number"
            min="0"
            step="100"
            name="timeout.limit"
            onChange={handleAuthData}
            value={timeout.limit}
            className="form-control form-control-sm"
            placeholder="Timeout Limit"
          />
        </CustomInputWithIcon>
      </div>
      <div className="col-md-6 col-lg-6 col-sm-6">
        <CustomInputWithIcon icon="text">
          <input
            name="timeout.message"
            onChange={handleAuthData}
            value={timeout.message}
            className="form-control form-control-sm"
            placeholder="Timeout Message"
          />
        </CustomInputWithIcon>
      </div>
    </div>
  );
};

export default TimeoutError;
